import { SERVER_URL } from "../../../constants";

const headers = (token) => ({
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
  Accept: "application/json",
});

// Both endpoints answer with a JSON body even on 400 (a row error names the row),
// so read the body first and only then decide whether to throw.
async function post(path, token, body) {
  const res = await fetch(`${SERVER_URL}${path}`, {
    method: "POST",
    headers: headers(token),
    body: JSON.stringify(body),
  });
  const text = await res.text().catch(() => "");
  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = null;
  }
  if (!res.ok && !(data && typeof data === "object" && "ok" in data)) {
    const msg = data?.message || data?.error || text || `HTTP ${res.status}`;
    const err = new Error(String(msg).slice(0, 300));
    err.status = res.status;
    throw err;
  }
  return data;
}

// Dry run: what each row would do, plus duplicate hits. Nothing written.
// rows: [{ row, studentId, fields }]
export const previewStudentCsv = (groupId, token, rows) =>
  post(`api/campgroup/${groupId}/students/csv/preview`, token, { rows });

// The real thing. rows carry a resolution (APPLY | CREATE_NEW | USE_EXISTING +
// existingStudentId | SKIP). Returns { ok, rows:[{row,outcome,studentId,note…}] }
// or { ok:false, row, error } when a row failed and nothing was written.
export const applyStudentCsv = (groupId, token, rows, createSurplus) =>
  post(`api/campgroup/${groupId}/students/csv/apply`, token, { rows, createSurplus });
